// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"729":"749566bb","4540":"c1b3da25"}[chunkId] + ".chunk.css";
};